<div class="si-check-dynamic {{styleClass}}"
     id="{{id}}"
     siProvideParentForm
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)">
  <div *ngIf="!hideLabel">
    <si-label [text]="text"
              styleClass="si-check-dynamic_label"
              [tooltipText]="tooltipText"
              [tooltipPosition]="tooltipPosition"
              [tooltipIcon]="tooltipIcon"
              [tooltipStyleClass]="tooltipStyleClass"
              [tooltipEscape]="tooltipEscape"
              [forceShowTooltipIcon]="forceShowTooltipIcon"
              (tooltipIconClick)="onClickTooltipIcon($event)"
              [disabled]="disabled"
    ></si-label>
  </div>
  <div *ngIf="!options?.length" class="si-check-dynamic_loader">
    <i class="icon-spinner"></i>
  </div>
  <div class="si-check-dynamic_container"
       [class.si-check-dynamic_container-horizontal]="!vertical">
      <div *ngFor="let option of options; let i = index" class="si-check-dynamic_check">
        <si-check id="dynamic-{{id}}-{{option.id}}"
                  name="dynamic-{{id}}-{{option.id}}"
                  [text]="option.name"
                  [(model)]="checkModel[i]"
                  (modelChange)="onChangeModel($event, option)"
                  styleClass="{{styleClassCheck}}"
                  [disabled]="disabled"
        ></si-check>
      </div>
    <input #formModel="ngModel"
           id="hiddenInputCheckDynamic{{id}}"
           name="hiddenInputCheckDynamic{{id}}"
           type="hidden"
           [disabled]="disabled"
           [ngModel]="checkModel"
           siValidation="{{rule}}"
           [siValidationElement]="validationElement"
           [siValidationExternalErrorText]="validationExternalErrorText"/>
    <si-validation-element #validationElement
                           [formModel]="formModel"
                           [showErrorText]="!showRuleErrorOutsideIcon"
                           (errorTextChange)="validationErrorText = $event"
                           class="si-check-dynamic_container_validation"
    ></si-validation-element>
  </div>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
